import BoldLabel from "./boldLabel";
export default function Label() {
  return (
    <div class="text-sm leading-7 p-4">
      Get Your <BoldLabel text="Message" /> Out There! Choose Your Advertising
      Medium:<br></br>
      Create a stunning <BoldLabel text="Advertisement" /> that captures your
      audience's attention and helps you achieve your{" "}
      <BoldLabel text="Marketing" /> goals. Select the option that best suits
      your needs and get <BoldLabel text="Started" /> today!{" "}
    </div>
  );
}
